import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import ReactNumberTicker from 'react-animate-number-ticker';
import 'react-animate-number-ticker/dist/index.css';
import { USDollar } from '../../utils/formatters.ts';

const PriceStockBlock = ({ lastUpdate, lastPrice, dayBefore }) => {
	const [lastPriceUpdate, setLastPriceUpdate] = useState(lastUpdate);
	const [price, setPrice] = useState(lastPrice);
	const [priceChanged, setPriceChanged] = useState(lastPrice - dayBefore);
	const [priceChangedPercent, setPriceChangedPercent] = useState(((lastPrice - dayBefore) / dayBefore) * 100);

	useEffect(() => {
		document.addEventListener(
			'PriceUpdate',
			(evt) => {
				let estDateString = new Date(evt.detail[0].date).toLocaleString('en-US', { timeZone: 'America/New_York' });
				setLastPriceUpdate(dayjs(estDateString).format('MM-DD-YYYY h:mma'));
				setPriceChanged(evt.detail[0].close - dayBefore);
				setPriceChangedPercent(((evt.detail[0].close - dayBefore) / dayBefore) * 100);
				setPrice(evt.detail[0].close);
			},
			false,
		);
	}, []);

	return (
		price && (
			<div className="flex flex-col items-end price-block">
				<p className="mb text-sm text-gray-700 dark:text-slate-200">as {lastPriceUpdate} EST</p>
				<div className="m-0 flex">
					<div className="mb-0 mr-2 font-bold text-gray-700 dark:text-slate-200 text-4xl">
						<ReactNumberTicker number={`${USDollar.format(price.toFixed(2))}`} />
					</div>
					<div className="flex flex-col">
						<div className={priceChanged > 0 ? 'm-0 font-bold text-green-700 text-sm' : 'm-0 font-bold text-red-600 text-sm'}>
							{priceChanged > 0 ? (
								<div>
									<span>+</span>
									<ReactNumberTicker number={USDollar.format(priceChanged)} />
								</div>
							) : (
								<div>
									<span>-</span>
									<ReactNumberTicker number={USDollar.format(Math.abs(priceChanged))} />
								</div>
							)}
						</div>
						<div className={priceChangedPercent > 0 ? 'm-0 font-bold text-green-700 text-sm' : 'm-0 font-bold text-red-600 text-sm'}>
							<ReactNumberTicker
								number={priceChangedPercent > 0 ? '+' + `${priceChangedPercent.toFixed(2)}%` : `${priceChangedPercent.toFixed(2)}%`}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	);
};

export default PriceStockBlock;
